import React from 'react';

const Textarea = (props) => (
    <div className="form-group">
        <label>{props.label}</label>
        <textarea
            className={props._className}
            placeholder={props.placeholder}
            value={props.value}
            onChange={props.onChange}
            rows={props.rows}>
        </textarea>
        {props.error &&
            <div className="invalid-feedback">
                {props.errorMessage ? props.errorMessage : `Le champ ${props.label} est obligatoire`}
            </div>
        }
    </div>
)

export default Textarea;


// WEBPACK FOOTER //
// ./src/components/Common/Textarea.js